import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-civics-public-service-and-safety',
  imports: [PillarPagesTemp],
  templateUrl: './civics-public-service-and-safety.html',
  styleUrl: './civics-public-service-and-safety.scss',
})
export class CivicsPublicServiceAndSafety {

}
